'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$002499 from "./presto.types$$anon$99.js";
import * as $j_presto$002etypes$0024$002dLimited$002dLocal$002dTime$0024 from "./presto.types$-Limited-Local-Time$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$98() {
  this.c3G = null;
  this.c3y = null;
  this.c3z = false;
  this.c3H = null;
  this.c3I = false;
  this.c3L = null;
  this.c3E = null;
  this.c3F = false;
  this.c3A = null;
  this.c3B = false;
  this.c3C = null;
  this.c3D = false;
  this.c3J = false;
  this.c3K = false;
  this.c3G = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.c3L = "LimitedLocalTime";
}
export { $c_Lpresto_types$$anon$98 as $c_Lpresto_types$$anon$98 };
$p = $c_Lpresto_types$$anon$98.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$98;
/** @constructor */
function $h_Lpresto_types$$anon$98() {
}
export { $h_Lpresto_types$$anon$98 as $h_Lpresto_types$$anon$98 };
$h_Lpresto_types$$anon$98.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.c3G;
});
$p.L = (function() {
  if ((!this.c3z)) {
    this.c3y = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.c3z = true;
  }
  return this.c3y;
});
$p.O = (function() {
  if ((!this.c3I)) {
    this.c3H = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.c3I = true;
  }
  return this.c3H;
});
$p.E = (function() {
  return this.c3L;
});
$p.t = (function() {
  if ((!this.c3F)) {
    this.c3E = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hour", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("minute", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c3F = true;
  }
  return this.c3E;
});
$p.M = (function() {
  if ((!this.c3B)) {
    this.c3A = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c3B = true;
  }
  return this.c3A;
});
$p.Q = (function() {
  if ((!this.c3D)) {
    this.c3C = new $j_presto$002etypes$0024$0024anon$002499.$c_Lpresto_types$$anon$99();
    this.c3D = true;
  }
  return this.c3C;
});
$p.w = (function() {
  if ((!this.c3K)) {
    this.c3J = false;
    this.c3K = true;
  }
  return this.c3J;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee140) => ((p) => \u03b4scrutinee140.crr(p)))($j_presto$002etypes$0024$002dLimited$002dLocal$002dTime$0024.$m_Lpresto_types$LimitedLocalTime$())));
});
var $d_Lpresto_types$$anon$98 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$98, "presto.types$$anon$98", ({
  Yl: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$$anon$98 as $d_Lpresto_types$$anon$98 };
//# sourceMappingURL=presto.types$$anon$98.js.map
